/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IBenefitsConfigVersion } from 'src/interfaces';
import BenefitsService from 'src/services/benefits.service';

export const usePostBenefitsConfigVersion = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    (bVersion: IBenefitsConfigVersion) => BenefitsService.postBenefitsConfigVersion(bVersion),
    {
      onSuccess: () => {
        AlertAdapter('Version created', 'success');
        queryClient.invalidateQueries(['benefits-config-version']);
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
  return mutation;
};
